// removed by extract-text-webpack-plugin
module.exports = {"bannerContainer":"bannerContainer__1ZG8m","bannerModule":"bannerModule__1-Qem","bannerModulePlayButton":"bannerModulePlayButton__17dyz","scrollWrapper":"scrollWrapper__hqTXv","bannerVideoGroup":"bannerVideoGroup__2DseK","videoItemWrap":"videoItemWrap__1-bpy","videoBadge":"videoBadge__2QohX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Banner/index.css
// module id = 648
// module chunks = 0